import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-96d7d658"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "max"
};
const _hoisted_3 = {
  class: "header_bg"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header_logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://static.readboy.com/web/wisdom-study-room/pc/home/读书郎AI爱学中心-logo.png",
  alt: ""
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "telephone",
  src: "https://static.readboy.com/web/wisdom-study-room/pc/home/ig_sy_01.png",
  alt: ""
}, null, -1));
const _hoisted_6 = {
  class: "min"
};
const _hoisted_7 = {
  class: "header_bg"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header_logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://static.readboy.com/web/wisdom-study-room/pc/home/读书郎AI爱学中心-logo.png",
  alt: ""
})], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "telephone",
  src: "https://static.readboy.com/web/wisdom-study-room/pc/home/ig_sy_01.png",
  alt: ""
}, null, -1));
import { ref, watchEffect } from 'vue';
export default {
  __name: 'HomeView',
  setup(__props) {
    const drawer = ref(false);
    const direction = ref('ttb');
    const routes = [{
      name: '首页',
      path: '/'
    }, {
      name: '产品介绍',
      path: '/product'
    }, {
      name: '核心技术',
      path: '/technology'
    }, {
      name: '招商与合作',
      path: '/cooperation'
    }];

    // 点击跳转时关闭抽屉
    const showClose = () => {
      drawer.value = !drawer.value;
    };
    const handleClose = done => {
      document.body.style.overflow = ''; // 启用滚动
      done();
    };
    const watchDrawer = () => {
      if (drawer.value) {
        document.body.style.overflow = 'hidden'; // 禁止滚动
      } else {
        document.body.style.overflow = ''; // 启用滚动
      }
    };

    watchEffect(() => {
      watchDrawer();
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("nav", null, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, route => {
        return _createElementVNode("li", {
          key: route.name
        }, [_createVNode(_component_router_link, {
          to: route.path
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(route.name), 1)]),
          _: 2
        }, 1032, ["to"])]);
      }), 64))])]), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("div", {
        class: _normalizeClass(["bt", drawer.value ? 'close' : '']),
        onClick: _cache[0] || (_cache[0] = $event => drawer.value = !drawer.value)
      }, null, 2)]), _createVNode(_component_el_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => drawer.value = $event),
        "before-close": handleClose,
        direction: direction.value,
        "show-close": false,
        "with-header": false,
        style: {
          "margin-top": "50px"
        },
        size: 250
      }, {
        default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, route => {
          return _createElementVNode("li", {
            key: route.name,
            class: "li_bottom"
          }, [_createVNode(_component_router_link, {
            to: route.path,
            onClick: showClose
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(route.name), 1)]),
            _: 2
          }, 1032, ["to"])]);
        }), 64))])]),
        _: 1
      }, 8, ["modelValue", "direction"])])]);
    };
  }
};